import api from "../../../plugins/api";

const cancelCreditAppeal = (appealId) => {
  return api.post('/api/bank/cancelCreditAppeal', { appealId });
};

export default cancelCreditAppeal;
